import React from "react"
import { Card, Box, Heading, Text, Flex, Skeleton } from "@radix-ui/themes"

interface DataCardProps {
  title: string | React.ReactNode
  subtitle?: string
  children: React.ReactNode
  className?: string
  loading?: boolean
  emptyMessage?: string
  isEmpty?: boolean
}

const DataCard: React.FC<DataCardProps> = ({
  title,
  subtitle,
  children,
  className = "",
  loading = false,
  emptyMessage = "No data available",
  isEmpty = false
}) => {
  return (
    <Card className={className}>
      <Box p="6">
        <Box mb="4">
          <Heading size="4" mb="1">
            {title}
          </Heading>
          {subtitle && (
            <Text size="2" color="gray">
              {subtitle}
            </Text>
          )}
        </Box>
        
        {loading ? (
          <Flex direction="column" gap="4">
            {[...Array(5)].map((_, i) => (
              <Skeleton key={i}>
                <Box height="16px" />
              </Skeleton>
            ))}
          </Flex>
        ) : isEmpty ? (
          <Flex justify="center" py="8">
            <Text color="gray">{emptyMessage}</Text>
          </Flex>
        ) : (
          <Flex direction="column" gap="4">
            {children}
          </Flex>
        )}
      </Box>
    </Card>
  )
}

export default DataCard 